module.exports = "//cdn.livechat-static.com/webapp/img/campaigns/intent-support-tooltip.png?94f2b08664abc31a7bc1e03fcd11ef5f";